import { Link } from 'react-router-dom';
import { getQuarter } from 'date-fns';
import _escapeRegExp from 'lodash/escapeRegExp';

export const renderHighlightsFragments = (textString, searchText) => {
  const regex = new RegExp(`(${_escapeRegExp(searchText)})`, 'gi');
  const parts = textString.split(regex);
  return parts
    .filter(part => part)
    .map((part, index) => (regex.test(part) ? <mark key={index}>{part}</mark> : <span key={index}>{part}</span>));
};

export const getCurrentQuarter = () => {
  return getQuarter(new Date());
};

export const getCurrentYear = () => {
  return new Date().getFullYear();
};

export const downloadFile = (response, filename) => {
  const url = window.URL.createObjectURL(response.body);
  const downloadLink = document.createElement('a');
  downloadLink.href = url;
  downloadLink.download = filename || response.fileName;
  document.body.appendChild(downloadLink);
  downloadLink.click();
  document.body.removeChild(downloadLink);
};

export const getLinkProps = ({ isExternal, link }) => {
  return {
    component: isExternal ? 'a' : Link,
    [isExternal ? 'href' : 'to']: link,
  };
};

export const groupBy = (array, key) =>
  array.reduce(
    (result, item) => ({
      ...result,
      [item[key]]: [...(result[item[key]] || []), item],
    }),
    {},
  );

export const isIBMUser = (email = '') => {
  const splittedEmail = email.split('@');
  return splittedEmail.length > 1 && splittedEmail[1].endsWith('ibm.com');
};
